import React, { useEffect, useState } from "react";
import axios from "axios";
import "./aside.css";


const PaymentForm = () => {
    const [schools, setSchools] = useState([]);
    const [selectedSchool, setSelectedSchool] = useState("");
    const [paidInfo, setPaidInfo] = useState([]);

    const [formData, setFormData] = useState({
        installment1_amount: "",
        installment1_paid_date: "",
        installment2_amount: "",
        installment2_paid_date: "",
        installment3_amount: "",
        installment3_paid_date: "",
        installment4_amount: "",
        installment4_paid_date: "",
        installment5_amount: "",
        installment5_paid_date: ""
    });

    const [file, setFile] = useState(null);

    // ✅ Fetch schools
    useEffect(() => {
        axios.get("https://cleezoclass.com:8443/api/mou/schools")
            .then(res => setSchools(res.data))
            .catch(err => console.log(err));
    }, []);

    // ✅ Fetch all payment data
    useEffect(() => {
        axios.get("https://cleezoclass.com:8443/api/mou/get-payment")
            .then(res => setPaidInfo(res.data))
            .catch(err => console.log(err));
    }, []);

    // ✅ Find selected school payment
    const schoolDetail = paidInfo.find(
        (p) => p.id === Number(selectedSchool)
    );

    // ✅ Auto-fill form
    useEffect(() => {
        if (schoolDetail) {
            setFormData({
                installment1_amount: schoolDetail.installment1_amount || "",
                installment1_paid_date: schoolDetail.installment1_paid_date?.split("T")[0] || "",

                installment2_amount: schoolDetail.installment2_amount || "",
                installment2_paid_date: schoolDetail.installment2_paid_date?.split("T")[0] || "",

                installment3_amount: schoolDetail.installment3_amount || "",
                installment3_paid_date: schoolDetail.installment3_paid_date?.split("T")[0] || "",

                installment4_amount: schoolDetail.installment4_amount || "",
                installment4_paid_date: schoolDetail.installment4_paid_date?.split("T")[0] || "",

                installment5_amount: schoolDetail.installment5_amount || "",
                installment5_paid_date: schoolDetail.installment5_paid_date?.split("T")[0] || ""
            });
        }
    }, [schoolDetail]);

    const handleSelect = (e) => {
        setSelectedSchool(e.target.value);
    };

    const handleChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value
        });
    };

    const handleFile = (e) => {
        setFile(e.target.files[0]);
    };

    const handleSubmit = async () => {
        try {
            const formDataToSend = new FormData();

            formDataToSend.append("mou_id", selectedSchool);

            if (file) {
                formDataToSend.append("paymentUpload", file);
            }

            Object.keys(formData).forEach((key) => {
                formDataToSend.append(key, formData[key] || "");
            });

            await axios.post(
                "https://cleezoclass.com:8443/api/mou/add-payment",
                formDataToSend,
                {
                    headers: { "Content-Type": "multipart/form-data" },
                }
            );

            alert("Payment uploaded successfully");

        } catch (err) {
            console.error(err);
        }
    };

    return (
        <div className="payment-container">

            <div className="payment-card">
                <div className="heading">
                    <h2>Centralization Payment Form</h2>
                </div>

                {/* Dropdown */}
                <div className="selectSchool">
                    <select value={selectedSchool} onChange={handleSelect}>
                        <option value="">Select School</option>
                        {schools.map((s) => (
                            <option key={s.id} value={s.id}>
                                {s.schoolName}
                            </option>
                        ))}
                    </select>
                    {/* File */}
                    <input type="file" onChange={handleFile} />
                </div>

                {/* Installments */}
                {[1, 2, 3, 4, 5].map((num) => (
                    <div className="row" key={num}>
                        <input
                            type="text"
                            name={`installment${num}_amount`}
                            placeholder={`Installment ${num} Amount`}
                            value={formData[`installment${num}_amount`]}
                            onChange={handleChange}
                        />
                        <input
                            type="date"
                            name={`installment${num}_paid_date`}
                            value={formData[`installment${num}_paid_date`]}
                            onChange={handleChange}
                        />
                    </div>
                ))}

                <div className="paymentsubdiv">
                    <button className="paymentSubBtn" onClick={handleSubmit}>Submit</button>
                </div>


            </div>
        </div>
    );
};

export default PaymentForm;